// extracted by mini-css-extract-plugin
module.exports = {"schemaItem":"SchemaSidebar_schemaItem__Qv9EK","expandable":"SchemaSidebar_expandable__1Fvb-","schemaSpinner":"SchemaSidebar_schemaSpinner__An3e8"};